import { useSessionStore } from "../store/useSessionStore";
import { resolveLiveExitUrl } from "../utils/live-exit-url";

/** Live-link Return to app (config.callbackUrl, then envelope callbackUrl). */
export function useLiveExitUrl(): string | undefined {
  return useSessionStore((s) => resolveLiveExitUrl(s.session.data));
}
